import { Box } from "@mui/material";
import { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../../../components/Header";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import DailyConsumptionForm from "../../../components/FormDaily";
import { useTranslation } from 'react-i18next';

const CreateDailyConsumption = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const apiUrl = "https://oven-backend.onrender.com";


  const handleFormSubmit = async (values) => {
    try {
      const formattedValues = {
        item: values.item,
        recordedBy: values.recordedBy,
        consumedAmount: Number(values.consumedAmount),
        consumptionDate: values.consumptionDate || new Date().toISOString(),
        notes: values.notes,
      };

      await axios.post(`${apiUrl}/dailyConsumption`, formattedValues);
      setOpen(true);
      console.log("✅ Daily Consumption recorded successfully:", formattedValues);
      setTimeout(() => {
        navigate("/dailyConsumption");
      }, 1000);
    } catch (error) {
      console.error("❌ Error recording daily consumption:", error.response?.data || error);
    }
  };

  return (
    <Box m="20px" sx={{ direction: isRTL ? 'rtl' : 'ltr' }}>
      <Header 
        title={t("create_daily_consumption")} 
        subtitle={t("record_new_consumption")} 
      />
      
      <DailyConsumptionForm 
        initialValues={{
          item: "",
          recordedBy: "",
          consumedAmount: "",
          consumptionDate: "",
          notes: "",
        }}
        handleFormSubmit={handleFormSubmit} 
        buttonLabel={t("add_record")}
      />

      <Snackbar open={open} autoHideDuration={6000} onClose={() => setOpen(false)}>
        <Alert onClose={() => setOpen(false)} severity="success" variant="filled" sx={{ width: '100%' }}>
          {t("success_added_consumption")}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CreateDailyConsumption;

